import { isDefined } from 'dg-web-shared/lib/MaybeV2.ts';
import { Translation } from '../../common/i18n/Text.ts';
import * as PermitCreateTexts from '../i18n/PermitCreateTexts.ts';
import * as PermitCreateState from '../state/PermitCreateState.ts';
import * as PermitTypeState from '../../common/state/PermitTypeState.ts';
import { Store, useStore } from 'dg-web-shared/lib/Flux.tsx';
import { getDurationString } from './PermitTimeUnitHelpers.ts';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';
import {
    Option,
    StringSingleSelectionSlideIn,
} from '../../ui/slidein/SingleSelectionSlideIn.tsx';

export interface Texts {
    DurationCaption: Translation;
}

export function PermitCreateValidityDurationSlideIn() {
    const { storeState, update } = useStore(store => ({
        layout: PermitCreateState.Layout.get(store),
        config: PermitCreateState.Config.get(store),
        permitType: PermitTypeState.getById(
            store,
            PermitCreateState.Config.get(store).permitTypeId,
        ),
    }));
    const { language } = useLanguage();

    function txt(): Texts {
        return PermitCreateTexts.validityDuration[language];
    }

    function getDurationOptions(): Option<string>[] {
        const t = storeState.permitType;
        if (isDefined(t)) {
            if (t.validDurationsV2) {
                return t.validDurationsV2.map(d => {
                    return {
                        id: d.uniqueId,
                        displayText: getDurationString(d, language),
                    };
                });
            }
        }
        return [];
    }

    function onDurationSelected(uniqueId: string): void {
        update((store: Store): string => {
            PermitCreateState.Config.stateWrite(store, {
                durationId: uniqueId,
            });
            PermitCreateState.Layout.stateWrite(store, {
                validityDurationPickerOpen: false,
            });
            PermitCreateState.Calc.reset(store);
            return 'PermitCreateValidityDurationSlideIn-selectDuration';
        });
    }

    function close(): void {
        update(store =>
            PermitCreateState.Layout.stateWrite(store, {
                validityDurationPickerOpen: false,
            }),
        );
    }

    const selectedDuration = storeState.config.durationId;
    const open = storeState.layout.validityDurationPickerOpen;
    return (
        <StringSingleSelectionSlideIn
            open={open}
            heading={txt().DurationCaption()}
            selection={selectedDuration}
            options={getDurationOptions()}
            onLeftActionClick={() => close()}
            onSelect={(duration: string) => onDurationSelected(duration)}
            outsideBody
        />
    );
}
